import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import _ from "lodash";
//import history from "../libs/history";
//import createLink from "../libs/createLink";

// import {observerRooms} from "../libs/socket";
// import store from "../store";


let redux = reduxCreator.type('ROOMS').plugin(axiosPlugin, {template: "array"});

export const removeOneFromStore = redux.action('RM_STORE', function (id = "") {
    return {
        id
    }
});

export const subscribeRoom = redux.action('SUBSCRIBE', function (params = {}) {
    return {
        subscribe: {
            path: 'ROOMS',
            params
        }
    }
});

export const unsubscribeRoom = redux.action('UNSUBSCRIBE', function () {
    return {
        unsubscribe: {
            type: redux.types.SUBSCRIBE
        }
    }
});

redux.reducerForType('RM_STORE', (state, action) => {
    let newState = {...state};
    newState.data = newState.data.filter(room => room._id !== action.id);
    return newState;
});
/*
redux.reducerForType('CREATE_STORE', (state, action) => {
    let newState = {...state};
    let currentRoomId = _.get(action, 'payload._id');
    if(!_.find(newState.data, {_id: currentRoomId.toString()})) {
        newState.data.unshift(action.payload);
        newState.total++;
        history.push(createLink("messengerRoom", {roomId: currentRoomId.toString()}))
    }
    return newState;
});*/

redux.reducerForType('SUBSCRIBE_DATA', (state, action) => {
    let newState = {...state};
    let operation = _.get(action, 'payload.op');
    let currentRoomId = _.get(action, 'payload._id');

    if(currentRoomId && operation){
        switch (operation) {
            case"update":
                newState.data = newState.data.map(item => {
                    if (item._id.toString() === currentRoomId.toString()) {
                        item = action.payload;
                    }
                    return item;
                });
                break;
            case"create":
                if(!_.find(newState.data, {_id: currentRoomId.toString()})) {
                    newState.data.unshift(action.payload);
                    newState.total++;
                }

                break;
            case"joint":
                if(!_.find(newState.data, {_id: currentRoomId.toString()})) {
                    //console.log("REJOINDRE", action);
                    newState.data.unshift(action.payload);
                    newState.total++;
                }
                break;

           case"exclude":

                newState.data = newState.data.filter(item => item._id.toString() !== currentRoomId.toString());
                newState.total--;
                if (newState.total < 0) {
                    newState.total = 0;
                }
                break;
            case"remove":
                //console.log("removeeeeee");
                //console.log(newState.data, currentRoomId);
                /* newState.data = newState.data.filter(item => item._id.toString() !== currentRoomId.toString());
                 newState.total--;
                 if (newState.total < 0) {
                     newState.total = 0;
                 }*/
                break;
            default :
               /* newState.data = newState.data.filter(item => item._id.toString() !== action.payload._id.toString());
                newState.total--;
                if (newState.total < 0) {
                    newState.total = 0;
                }*/
        }
    }

    return newState;
});


let fetchRoomsAction = redux.fetchActionGet();

export const TYPES = redux.types;

export const fetchRooms = (query = {}, more = false) => fetchRoomsAction(`/rooms?${queryString.stringify(query)}`, null, {more});
export const resetRooms = () => redux.actions.reset();

export const rooms = redux.reducer();